import React from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
  Stack,
  Typography,
} from "@mui/material";
import { GroupType } from "../../lib/types";

interface GroupTypeSelectorProps {
  value: GroupType;
  onChange: (value: GroupType) => void;
}

const GroupTypeSelector: React.FC<GroupTypeSelectorProps> = ({
  value,
  onChange,
}) => {
  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2" color="text.secondary">
        Group type
      </Typography>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, nextValue) => {
          if (nextValue) {
            onChange(nextValue);
          }
        }}
        size="small"
        aria-label="Group type"
      >
        <ToggleButton value="family" aria-label="Family group">
          Family
        </ToggleButton>
        <ToggleButton value="business" aria-label="Business group">
          Business
        </ToggleButton>
        <ToggleButton value="custom" aria-label="Custom group">
          Custom
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
};

export default GroupTypeSelector;
